import React, { useEffect, useState } from "react";
import { Modal, Row, Col, CardBody, Card, Container, Button, Input } from "reactstrap";
import 'toastr/build/toastr.min.css';
import { StoreService } from '../../services/storeService';
import './button.scss';
import './CartList.scss';
import { useHistory, useParams } from 'react-router-dom';
import { Link } from "react-router-dom";
// Rating Plugin
import toastr, { success } from 'toastr'
import { useDispatch, useSelector } from 'react-redux'
import { addToCart, deleteProductCart, delete_products_from_cart, addHistory, removeHistory } from '../../store/auth/cart/actions'
import { connect } from 'react-redux'


import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Loguin from "../authentication/Login";
import Register from "../authentication/Register";


function CartList({ countercart }) {
    const user = useSelector(x => x.Login.user);
    const storeService = new StoreService();
    const params = useParams();
    const history = useHistory();
    const cart = useSelector(store => store.cart.countercart);
    const dispatch = useDispatch()
    const [productsByStore, setproductsByStore] = useState([])
    const [modalIngreso, setModalIngreso] = useState(false);

    const [value, setValue] = React.useState(0);

    const formatterPeso = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0
    })

    const validationToBuy = () => {
        if (user) {
            history.push({
                pathname: `/SendProducts`, //TODO: Qar Aquí no debe pasar un Id porque solo hay una tienda.
                state: { productos: productsByStore }
            })
        }

        else {
            // toastr.info('Para realizar esta accón debe estar logueado, por favor inicie sesión o cree una cuenta en Andimat', <button type="button" class="btn clear">Cancelar</button>, 'Información',
            //     {
            //         "preventDuplicates": true,
            //         "tapToDismiss": false
            //     })
            dispatch(addHistory({
                pathname: `/SendProducts`, //TODO: Qar Aquí no debe pasar un Id porque solo hay una tienda.
                state: { productos: productsByStore }
            }))
            setModalIngreso(true)
            //falta poner dos botones, uno que cierre el toastr y otro con el link de iniciar sesion
        }


    }

    useEffect(() => {
        if (!modalIngreso) {
            dispatch(removeHistory())
        }
    }, [modalIngreso])

    useEffect(() => {
        const data = cart;
        console.log(data)//.filter(store => store.idStore == params.id)
        setproductsByStore(data)
        console.log(data)
    }, [cart])
    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const TabPanel = (props) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const useStyles = makeStyles((theme) => ({
        root: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
        },
    }));

    const classes = useStyles();

    const AddProduct = (p) => {
        console.log(JSON.stringify(p))
        if (p.existencia > p.count) {
            dispatch(addToCart(p))
        }
        else {
            toastr.info('No existe en inventario la cantidad solicitada.', 'Advertencia',
                {
                    "preventDuplicates": true
                }
            )
        }

    }
    console.log("--------->", productsByStore)
    // aqui se encuentra la informacion de  las compras que se va a relaizar esto esta en el carrito 
    return (

        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                <Container style={{ backgroundColor: 'transparent' }}>
                    <Row className="justify-content-center">
                        <Col md={10} lg={10} xl={10} style={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', height: "auto" }}>
                            <Card className="" style={{ height: "auto", backgroundColor: 'transparent' }}>
                                <Row className="d-flex justify-center-center pt-4 pb-3 ml-4">
                                    <h3 style={{ fontFamily: 'inherit' }} className="col-md-6 m-auto" >Carro de compras</h3>
                                    <h3 className="col-md-4 m-auto">
                                        {formatterPeso.format(Math.round(productsByStore.reduce((a, b) => { return a + b.price * b.count }, 0)))}
                                    </h3>
                                </Row>
                                <CardBody className="" style={{ height: "auto", backgroundColor: 'transparent' }}>
                                    <Row style={{ backgroundColor: 'white' }}>
                                        {productsByStore.length === 0 ?
                                            <span className="text-aling-center">No hay productos</span>
                                            :
                                            productsByStore.map((product, key) => {
                                                return <li className="list-group-item col-md-12" key={key} style={{ backgroundColor: 'transparent' }} >
                                                    <Row style={{ backgroundColor: 'transparent' }}>
                                                        <Col className="md-4 ml-1">
                                                            <img src={product.image} alt={product.name} style={{ height: "75px" }} />
                                                        </Col>
                                                        <Col md={7}>
                                                            <span className="store-name">{product.name}</span><br></br>
                                                           
                                                            <strong className="store-name">{formatterPeso.format(Math.round(product.price * product.count))}</strong><br></br>
                                                            <div className="d-flex justify-content-left pt-4" >
                                                                <span className="mr-3">Cantidad</span>
                                                                <button className="btn btn-primary rounded" style={{ padding: '3px 6px' }}
                                                                    onClick={() => dispatch(deleteProductCart(product))}>
                                                                    <i className="fas fa-minus"></i>
                                                                </button>

                                                                {/* Jose: esto no debería ser un H5 */}
                                                                <h5 className="m-1">{product.count}</h5>

                                                                <button className="btn btn-primary rounded " style={{ padding: '3px 6px' }}
                                                                    onClick={() => AddProduct(product)}>
                                                                    <i className="fas fa-plus"></i>
                                                                </button>
                                                            </div>
                                                        </Col>
                                                        <Col className="col-1 mt-3">
                                                            <input onClick={() => dispatch(delete_products_from_cart(product))} className="boton-imagen" type="button" value="  " />
                                                        </Col>
                                                    </Row>
                                                </li>

                                            })
                                        }
                                    </Row>
                                    {
                                        cart.length > 0 ?
                                            <Row>
                                                <Col className="mt-4 col-lg-6 col-md-6">
                                                    <button className="boton2-fanero btn-block text-center" onClick={() => validationToBuy()}>Comprar</button>

                                                </Col>
                                                <Col className="mt-4 col-lg-6 col-md-6">
                                                    <Link to={'/home'} className="boton3-fanero btn-block text-center">
                                                        <span style={{ color: 'black' }} >Seguir comprando</span></Link>
                                                </Col>
                                            </Row>
                                            :
                                            null
                                    }


                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            <Modal isOpen={modalIngreso} className="modal-dialog modal-xl">
                <div className="modal-header">
                    <h5 className="modal-title mt-0" id="mySmallModalLabel" >
                        <label htmlFor="" className="control-label m-3">
                            Para continuar con tu compra regístrate o inicia sesión
                        </label>
                    </h5>
                    <button onClick={() => setModalIngreso(false)} type="button" className="close" data-dismiss="modal" aria-label="Close" >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div >
                        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" centered indicatorColor="primary" textColor="primary">
                            <Tab label="Ingresar" {...a11yProps(0)} />
                            <Tab label="Registrarse" {...a11yProps(1)} />

                        </Tabs>
                        <TabPanel value={value} index={0}>
                            <Loguin />
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <Register />
                        </TabPanel>

                    </div>
                </div>
            </Modal>

        </React.Fragment>

    );

}
const mapStateToProps = state => {
    const { countercart } = state.cart;
    return { countercart };
}
export default connect(mapStateToProps, null)(CartList);